// extracted by mini-css-extract-plugin
module.exports = {"fontCgIcons":"icon_fontCgIcons__KnIQ7","icon":"icon_icon__2PyiF"};